import React from 'react';
import './PageLoading.css';

const PageLoading = () => {
  return (
    <div className="global-page-loading">
      <div className="loading-spinner-wrapper">
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default PageLoading;
